export enum UserNotificationType {
  CAMPAIGN = 'CAMPAIGN',
  WEATHER = 'WEATHER',
  APPOINTMENT = 'APPOINTMENT',
  VEHICLE_RETURN = 'VEHICLE_RETURN',
  OVERDUE_INVOICE = 'OVERDUE_INVOICE',
  CAR_BUY = 'CAR_BUY',
  CAR_INSPECTION = 'CAR_INSPECTION',
  KM_EXCEEDED = 'KM_EXCEEDED',
  PAYMENT_DUE_DATE = 'PAYMENT_DUE_DATE',
  HEDEFNET_DUE_DATE = 'HEDEFNET_DUE_DATE',
}
